import axios from "axios";
import autoriz from "../../models/gestionTiempos/autoriz";
import coments from "../../models/gestionTiempos/coments";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getAutoriz(date) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let empId = localStorage.getItem("empId");
    return axios
      .get(`${url}/autoriz/${empId}&${date}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return autoriz.fromJson(item);
        })
      );
  }
  /*  se usa getComentNov
   getComent() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/coments/autoriz`, { headers }).then(({ data }) =>
      data.map((item) => {
        return coments.fromJson(item);
      })
    );
  } */
  getComentNov() {
    let token = localStorage.getItem("token");
    let operId = parseInt(localStorage.getItem("operId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/coments/bnov/${operId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return coments.fromJson(item);
        })
      );
  }

  delete = (data) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let empId = data.empId;
    let fecha = data.date;
    let desde = data.from;

    return axios.delete(`${url}/autoriz/${empId}&${fecha}&${desde}`, {
      headers,
    });
  };
  edit = (data) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let empId = data.empId;
    let fecha = data.date;
    let desde = data.desde;
    let payload = {
      desde: data.timeFrom,
      hasta: data.timeTo,
      comentId: data.comentId,
    };

    return axios
      .patch(`${url}/autoriz/${empId}&${fecha}&${desde}`, payload, { headers })
      .then(() => {});
  };
  new = (data) => {
    let token = localStorage.getItem("token");
    let empId = parseInt(localStorage.getItem("empId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      empId: empId,
      fecha: data.date + "T00:00:00.000Z",
      desde: data.from,
      hasta: data.to,
      comentId: data.comentId,
    };

    return axios.post(`${url}/autoriz`, payload, { headers });
  };
}
export default service;
